import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { a11yDark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import './CodeBlock.css';

function CodeBlock({data}){
    return(
        <section>
            <div className="CodeArea">
                <SyntaxHighlighter className="CodeWindow" language="javascript" style={a11yDark} wrapLines={true}>
                    {data}
                </SyntaxHighlighter>
            </div>
        </section>
    );
}

export default CodeBlock;